import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Index from '../components/Index.vue'
import Article from '../components/articles/Article.vue'
import Articles from '../components/articles/Articles.vue'
import Users from '../components/users/Users.vue'
import UserEditor from '../components/users/UserEditor.vue'
import ability, {defineAbilitiesFor} from '../util/abilities';
import store from '../store'

import * as routes from './routes';

Vue.use(Router);

const canNavigate = (to) => {
    return to.matched.some(route => {
        return ability.can('manage', route.name)
    }) || to.path === routes.FORBIDDEN.route;
};

export default {
    router: new Router({
        mode: 'history',
        routes: [
            {
                path: routes.DASHBOARD.route,
                name: routes.DASHBOARD.name,
                component: Index,
            },
            {
                path: routes.LOGIN.route,
                name: routes.LOGIN.name,
                component: Login,
                meta: {
                    excludeAuth: true,
                    layout: 'anon'
                }
            },
            {
                path: routes.INDEX.route,
                name: routes.INDEX.name,
                component: Index,
            },
            {
                path: routes.USER_CREATOR.route,
                name: routes.USER_CREATOR.name,
                component: UserEditor,
            },
            {
                path: routes.USER_EDITOR.route,
                name: routes.USER_EDITOR.name,
                component: UserEditor,
                props: (route) => {
                    return {userIdIn: route.params.userId}
                },
            },
            {
                path: routes.USERS.route,
                name: routes.USERS.name,
                component: Users
            },
            {
                path: routes.ARTICLE_CREATOR.route,
                name: routes.ARTICLE_CREATOR.name,
                component: Article,
            },
            {
                path: routes.ARTICLE_EDITOR.route,
                name: routes.ARTICLE_EDITOR.name,
                component: Article,
                props: (route) => {
                    const slug = route.params.slug;
                    return {slug}
                },
            },
            {
                path: routes.ARTICLES.route,
                name: routes.ARTICLES.name,
                component: Articles
            },
            {
                path: '*',
                component: Index,
            },
        ]
    }),
    init() {
        if(store.getters.getUser && store.getters.getUser.email)
            defineAbilitiesFor(store.getters.getUser );
        this.router.beforeEach(async (to, from, next) => {
            if (to.meta.excludeAuth) {
                if (!store.getters.isAuthenticated)
                    next();
                else
                    next(routes.DASHBOARD.route)

            } else {
                if (store.getters.isAuthenticated) {
                    if (canNavigate(to))
                        next();
                    else
                        return next(routes.FORBIDDEN.route)
                } else {
                    next(routes.LOGIN.route)
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/router/index.js